/* tslint:disable */
/* eslint-disable */
/**
 * Stacks Blockchain API
 * Welcome to the API reference overview for the [Stacks Blockchain API](https://docs.hiro.so/stacks-blockchain-api).  [Download Postman collection](https://hirosystems.github.io/stacks-blockchain-api/collection.json) 
 *
 * The version of the OpenAPI document: STACKS_API_VERSION
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    NonFungibleTokenHistoryEventList,
    NonFungibleTokenHistoryEventListFromJSON,
    NonFungibleTokenHistoryEventListToJSON,
    NonFungibleTokenHoldingsList,
    NonFungibleTokenHoldingsListFromJSON,
    NonFungibleTokenHoldingsListToJSON,
    NonFungibleTokenMintList,
    NonFungibleTokenMintListFromJSON,
    NonFungibleTokenMintListToJSON,
} from '../models';

export interface GetNftHistoryRequest {
    assetIdentifier: string;
    value: string;
    limit?: number;
    offset?: number;
    unanchored?: boolean;
    txMetadata?: boolean;
}

export interface GetNftHoldingsRequest {
    principal: string;
    assetIdentifiers?: Array<string>;
    limit?: number;
    offset?: number;
    unanchored?: boolean;
    txMetadata?: boolean;
}

export interface GetNftMintsRequest {
    assetIdentifier: string;
    limit?: number;
    offset?: number;
    unanchored?: boolean;
    txMetadata?: boolean;
}

/**
 * NonFungibleTokensApi - interface
 * 
 * @export
 * @interface NonFungibleTokensApiInterface
 */
export interface NonFungibleTokensApiInterface {
    /**
     * Retrieves all events relevant to a Non-Fungible Token. Useful to determine the ownership history of a particular asset.  More information on Non-Fungible Tokens on the Stacks blockchain can be found [here](https://docs.stacks.co/write-smart-contracts/tokens#non-fungible-tokens-nfts). 
     * @summary Non-Fungible Token history
     * @param {string} assetIdentifier token asset class identifier
     * @param {string} value hex representation of the token\&#39;s unique value
     * @param {number} [limit] max number of events to fetch
     * @param {number} [offset] index of first event to fetch
     * @param {boolean} [unanchored] whether or not to include events from unconfirmed transactions
     * @param {boolean} [txMetadata] whether or not to include the complete transaction metadata instead of just &#x60;tx_id&#x60;. Enabling this option can affect performance and response times.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NonFungibleTokensApiInterface
     */
    getNftHistoryRaw(requestParameters: GetNftHistoryRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<NonFungibleTokenHistoryEventList>>;

    /**
     * Retrieves all events relevant to a Non-Fungible Token. Useful to determine the ownership history of a particular asset.  More information on Non-Fungible Tokens on the Stacks blockchain can be found [here](https://docs.stacks.co/write-smart-contracts/tokens#non-fungible-tokens-nfts). 
     * Non-Fungible Token history
     */
    getNftHistory(requestParameters: GetNftHistoryRequest, initOverrides?: RequestInit): Promise<NonFungibleTokenHistoryEventList>;

    /**
     * Retrieves the list of Non-Fungible Tokens owned by the given principal (STX address or Smart Contract ID). Results can be filtered by one or more asset identifiers and can include metadata about the transaction that made the principal own each token.  More information on Non-Fungible Tokens on the Stacks blockchain can be found [here](https://docs.stacks.co/write-smart-contracts/tokens#non-fungible-tokens-nfts). 
     * @summary Non-Fungible Token holdings
     * @param {string} principal token owner\&#39;s STX address or Smart Contract ID
     * @param {Array<string>} [assetIdentifiers] identifiers of the token asset classes to filter for
     * @param {number} [limit] max number of tokens to fetch
     * @param {number} [offset] index of first tokens to fetch
     * @param {boolean} [unanchored] whether or not to include tokens from unconfirmed transactions
     * @param {boolean} [txMetadata] whether or not to include the complete transaction metadata instead of just &#x60;tx_id&#x60;. Enabling this option can affect performance and response times.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NonFungibleTokensApiInterface
     */
    getNftHoldingsRaw(requestParameters: GetNftHoldingsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<NonFungibleTokenHoldingsList>>;

    /**
     * Retrieves the list of Non-Fungible Tokens owned by the given principal (STX address or Smart Contract ID). Results can be filtered by one or more asset identifiers and can include metadata about the transaction that made the principal own each token.  More information on Non-Fungible Tokens on the Stacks blockchain can be found [here](https://docs.stacks.co/write-smart-contracts/tokens#non-fungible-tokens-nfts). 
     * Non-Fungible Token holdings
     */
    getNftHoldings(requestParameters: GetNftHoldingsRequest, initOverrides?: RequestInit): Promise<NonFungibleTokenHoldingsList>;

    /**
     * Retrieves all mint events for a Non-Fungible Token asset class. Useful to determine which NFTs of a particular collection have been claimed.  More information on Non-Fungible Tokens on the Stacks blockchain can be found [here](https://docs.stacks.co/write-smart-contracts/tokens#non-fungible-tokens-nfts). 
     * @summary Non-Fungible Token mints
     * @param {string} assetIdentifier token asset class identifier
     * @param {number} [limit] max number of events to fetch
     * @param {number} [offset] index of first event to fetch
     * @param {boolean} [unanchored] whether or not to include events from unconfirmed transactions
     * @param {boolean} [txMetadata] whether or not to include the complete transaction metadata instead of just &#x60;tx_id&#x60;. Enabling this option can affect performance and response times.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NonFungibleTokensApiInterface
     */
    getNftMintsRaw(requestParameters: GetNftMintsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<NonFungibleTokenMintList>>;

    /**
     * Retrieves all mint events for a Non-Fungible Token asset class. Useful to determine which NFTs of a particular collection have been claimed.  More information on Non-Fungible Tokens on the Stacks blockchain can be found [here](https://docs.stacks.co/write-smart-contracts/tokens#non-fungible-tokens-nfts). 
     * Non-Fungible Token mints
     */
    getNftMints(requestParameters: GetNftMintsRequest, initOverrides?: RequestInit): Promise<NonFungibleTokenMintList>;

}

/**
 * 
 */
export class NonFungibleTokensApi extends runtime.BaseAPI implements NonFungibleTokensApiInterface {

    /**
     * Retrieves all events relevant to a Non-Fungible Token. Useful to determine the ownership history of a particular asset.  More information on Non-Fungible Tokens on the Stacks blockchain can be found [here](https://docs.stacks.co/write-smart-contracts/tokens#non-fungible-tokens-nfts). 
     * Non-Fungible Token history
     */
    async getNftHistoryRaw(requestParameters: GetNftHistoryRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<NonFungibleTokenHistoryEventList>> {
        if (requestParameters.assetIdentifier === null || requestParameters.assetIdentifier === undefined) {
            throw new runtime.RequiredError('assetIdentifier','Required parameter requestParameters.assetIdentifier was null or undefined when calling getNftHistory.');
        }

        if (requestParameters.value === null || requestParameters.value === undefined) {
            throw new runtime.RequiredError('value','Required parameter requestParameters.value was null or undefined when calling getNftHistory.');
        }

        const queryParameters: any = {};

        if (requestParameters.assetIdentifier !== undefined) {
            queryParameters['asset_identifier'] = requestParameters.assetIdentifier;
        }

        if (requestParameters.value !== undefined) {
            queryParameters['value'] = requestParameters.value;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.unanchored !== undefined) {
            queryParameters['unanchored'] = requestParameters.unanchored;
        }

        if (requestParameters.txMetadata !== undefined) {
            queryParameters['tx_metadata'] = requestParameters.txMetadata;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/extended/v1/tokens/nft/history`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NonFungibleTokenHistoryEventListFromJSON(jsonValue));
    }

    /**
     * Retrieves all events relevant to a Non-Fungible Token. Useful to determine the ownership history of a particular asset.  More information on Non-Fungible Tokens on the Stacks blockchain can be found [here](https://docs.stacks.co/write-smart-contracts/tokens#non-fungible-tokens-nfts). 
     * Non-Fungible Token history
     */
    async getNftHistory(requestParameters: GetNftHistoryRequest, initOverrides?: RequestInit): Promise<NonFungibleTokenHistoryEventList> {
        const response = await this.getNftHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves the list of Non-Fungible Tokens owned by the given principal (STX address or Smart Contract ID). Results can be filtered by one or more asset identifiers and can include metadata about the transaction that made the principal own each token.  More information on Non-Fungible Tokens on the Stacks blockchain can be found [here](https://docs.stacks.co/write-smart-contracts/tokens#non-fungible-tokens-nfts). 
     * Non-Fungible Token holdings
     */
    async getNftHoldingsRaw(requestParameters: GetNftHoldingsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<NonFungibleTokenHoldingsList>> {
        if (requestParameters.principal === null || requestParameters.principal === undefined) {
            throw new runtime.RequiredError('principal','Required parameter requestParameters.principal was null or undefined when calling getNftHoldings.');
        }

        const queryParameters: any = {};

        if (requestParameters.principal !== undefined) {
            queryParameters['principal'] = requestParameters.principal;
        }

        if (requestParameters.assetIdentifiers) {
            queryParameters['asset_identifiers'] = requestParameters.assetIdentifiers;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.unanchored !== undefined) {
            queryParameters['unanchored'] = requestParameters.unanchored;
        }

        if (requestParameters.txMetadata !== undefined) {
            queryParameters['tx_metadata'] = requestParameters.txMetadata;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/extended/v1/tokens/nft/holdings`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NonFungibleTokenHoldingsListFromJSON(jsonValue));
    }

    /**
     * Retrieves the list of Non-Fungible Tokens owned by the given principal (STX address or Smart Contract ID). Results can be filtered by one or more asset identifiers and can include metadata about the transaction that made the principal own each token.  More information on Non-Fungible Tokens on the Stacks blockchain can be found [here](https://docs.stacks.co/write-smart-contracts/tokens#non-fungible-tokens-nfts). 
     * Non-Fungible Token holdings
     */
    async getNftHoldings(requestParameters: GetNftHoldingsRequest, initOverrides?: RequestInit): Promise<NonFungibleTokenHoldingsList> {
        const response = await this.getNftHoldingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all mint events for a Non-Fungible Token asset class. Useful to determine which NFTs of a particular collection have been claimed.  More information on Non-Fungible Tokens on the Stacks blockchain can be found [here](https://docs.stacks.co/write-smart-contracts/tokens#non-fungible-tokens-nfts). 
     * Non-Fungible Token mints
     */
    async getNftMintsRaw(requestParameters: GetNftMintsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<NonFungibleTokenMintList>> {
        if (requestParameters.assetIdentifier === null || requestParameters.assetIdentifier === undefined) {
            throw new runtime.RequiredError('assetIdentifier','Required parameter requestParameters.assetIdentifier was null or undefined when calling getNftMints.');
        }

        const queryParameters: any = {};

        if (requestParameters.assetIdentifier !== undefined) {
            queryParameters['asset_identifier'] = requestParameters.assetIdentifier;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.unanchored !== undefined) {
            queryParameters['unanchored'] = requestParameters.unanchored;
        }

        if (requestParameters.txMetadata !== undefined) {
            queryParameters['tx_metadata'] = requestParameters.txMetadata;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/extended/v1/tokens/nft/mints`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NonFungibleTokenMintListFromJSON(jsonValue));
    }

    /**
     * Retrieves all mint events for a Non-Fungible Token asset class. Useful to determine which NFTs of a particular collection have been claimed.  More information on Non-Fungible Tokens on the Stacks blockchain can be found [here](https://docs.stacks.co/write-smart-contracts/tokens#non-fungible-tokens-nfts). 
     * Non-Fungible Token mints
     */
    async getNftMints(requestParameters: GetNftMintsRequest, initOverrides?: RequestInit): Promise<NonFungibleTokenMintList> {
        const response = await this.getNftMintsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
